import React from "react";
import { ChartNoAxesCombined } from "lucide-react";
import "../css/marketDepthIcon.css";

const MARKET_DEPTH_BLUE = "#2457BF";

/**
 * Market depth / order-book action — consistent Lucide styling app-wide.
 */
export default function MarketDepthIcon({
  size = 18,
  className = "",
  style,
  ...rest
}) {
  return (
    <ChartNoAxesCombined
      size={size}
      color={MARKET_DEPTH_BLUE}
      strokeWidth={2.25}
      aria-hidden
      className={`market-depth-icon ${className}`.trim()}
      style={{
        display: "block",
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    />
  );
}
